import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWeb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.193 14.204A8 8 0 0 0 10 18h.006a8.02 8.02 0 0 0 7.402-4.919 8.02 8.02 0 0 0 0-6.153A8.02 8.02 0 0 0 10.005 2H10a8 8 0 0 0-8 8v.002a8 8 0 0 0 .613 3.08q.248.587.58 1.122m6.245 2.272v-2.988H7.112a9.8 9.8 0 0 0 1.347 2.828q.477.117.979.16m-2.723-.866a11.7 11.7 0 0 1-.824-2.15H4.496a6.5 6.5 0 0 0 2.219 2.15m-2.791-3.296h1.71a12.8 12.8 0 0 1 0-4.584H3.906A6.5 6.5 0 0 0 3.5 10c0 .815.15 1.595.424 2.314m.545-5.73h1.422c.21-.765.496-1.506.855-2.212a6.53 6.53 0 0 0-2.277 2.212M8.517 3.67a9.8 9.8 0 0 0-1.428 2.942h2.349V3.524a6.5 6.5 0 0 0-.921.146m3.054 12.639q-.48.12-.987.165V13.46h2.35a9.8 9.8 0 0 1-1.363 2.849m3.933-2.85a6.5 6.5 0 0 1-2.188 2.133q.511-1.026.815-2.132zm.589-5.73A6.5 6.5 0 0 1 16.5 10c0 .815-.15 1.595-.424 2.314H14.39a12.8 12.8 0 0 0 0-4.584h1.704ZM13.286 4.39a6.53 6.53 0 0 1 2.245 2.194h-1.4a11.7 11.7 0 0 0-.845-2.194m-1.78-.714a9.8 9.8 0 0 1 1.404 2.908h-2.326V3.526q.473.042.923.15ZM6.803 7.73a12 12 0 0 0-.229 2.292c.004.77.08 1.537.23 2.292h2.635V7.73H6.802Zm3.782 0v4.584h2.636c.149-.755.225-1.523.229-2.292-.004-.77-.08-1.537-.23-2.292z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWeb;
